import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  bgColor?: string;
}

export const Wrapper = styled.p`
  background: #f0f0f0;
  border-radius: 4px;
  color: ${COLORS.GRAY_DARK};
  font-family: ${FONTS.ROBOTO};
  font-size: 13px;
  font-weight: 600;
  padding: 0 9px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  line-height: 32px;
`;

export const Igv = styled.span`
  font-size: 10px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
  }
`;

export const Price = styled.span`
  margin-left: auto;
  font-size: 14px;
  color: ${COLORS.BLACK_BOLD};
`;

export const Payment = styled.span`
  color: ${COLORS.BLACK_BOLD};
  margin-right: 6px;
`;